/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Literature-formula weight computed post-hoc from a provider's own
 * length estimate (see app/species/length_weight.py).
 * @export
 * @interface FormulaWeightRecord
 */
export interface FormulaWeightRecord {
    /**
     * 
     */
    weightG: number;
    /**
     * 
     */
    species: string;
    /**
     * 
     */
    lengthType: string;
    /**
     * 
     */
    source: string;
}

/**
 * Check if a given object implements the FormulaWeightRecord interface.
 */
export function instanceOfFormulaWeightRecord(value: object): value is FormulaWeightRecord {
    if ((!('weightG' in (value as Record<string, any>)) && !('weight_g' in (value as Record<string, any>))) || ((value as Record<string, any>)['weightG'] === undefined && (value as Record<string, any>)['weight_g'] === undefined)) return false;
    if (!('species' in value) || value['species'] === undefined) return false;
    if ((!('lengthType' in (value as Record<string, any>)) && !('length_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthType'] === undefined && (value as Record<string, any>)['length_type'] === undefined)) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function FormulaWeightRecordFromJSON(json: any): FormulaWeightRecord {
    return FormulaWeightRecordFromJSONTyped(json, false);
}

export function FormulaWeightRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulaWeightRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'weightG': json['weight_g'],
        'species': json['species'],
        'lengthType': json['length_type'],
        'source': json['source'],
    };
}

export function FormulaWeightRecordToJSON(json: any): FormulaWeightRecord {
    return FormulaWeightRecordToJSONTyped(json, false);
}

export function FormulaWeightRecordToJSONTyped(value?: FormulaWeightRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weight_g': value['weightG'],
        'species': value['species'],
        'length_type': value['lengthType'],
        'source': value['source'],
    };
}

